import Vue from 'vue/dist/vue.esm'
import TurbolinksAdapter from 'vue-turbolinks';
import VueLazyload from 'vue-lazyload'
import Vuex from 'vuex'
import Router from 'vue-router'
import router from './router'
import App from '../app.vue'
import store from './store'
import 'babel-polyfill'
require('jquery')

Vue.use(Vuex)
Vue.use(Router);
Vue.use(TurbolinksAdapter);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  observer: true,
  throttleWait: 200,
})
Vue.component('app', App);

document.addEventListener('turbolinks:load', () => {
  const app = new Vue({
    el: '[data-behavior="vue"]',
    router: router,
    store: store
  })
})

document.addEventListener('turbolinks:load', () => {
  // OSの設定がダークモード
  // const osDark = window.matchMedia("(prefers-color-scheme: dark)");
  // const listener = (event) => {
  //   if (event.matches) {
  //     darkModeOn();
  //   } else {
  //     darkModeOff();
  //   }
  // };
  // osDark.addEventListener("change", listener);
  // listener(osDark);

  function darkModeOn() {
    document.documentElement.classList.add("darkmode"); // ルート要素<html>にクラスを追加
    modeSwitch.checked = true;
  }

  function darkModeOff() {
    document.documentElement.classList.remove("darkmode"); // クラスの削除
    modeSwitch.checked = false;
  }

  const modeSwitch = document.getElementById("myonoffswitch");

  modeSwitch.addEventListener("change", () => {
    if (modeSwitch.checked) {
      darkModeOn();
      sessionStorage.setItem("darkMode", "on");
    } else {
      darkModeOff();
      sessionStorage.setItem("darkMode", "off");
    }
  });

  if (sessionStorage.getItem("darkMode") === "on") {
    darkModeOn();
  } else if (sessionStorage.getItem("darkMode") === "off") {
    darkModeOff();
  }
})